/** Thrown by create/update when the L1 validate hook reports errors. */
export class EntityValidationError extends Error {
    constructor(errors) {
        super('Validation failed');
        this.errors = errors;
        this.name = 'EntityValidationError';
    }
}
//# sourceMappingURL=types.js.map